<template>
    <div>

  
        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <p class="is-size-5"> Status  </p>
                </div>
                <div class="level-item">
                    <p v-if="dataBACTSpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataBACTSpecLN.status.name }}  </p>
                    <p v-if="dataBACTSpecLN.status.id >=5 && dataBACTSpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataBACTSpecLN.status.name }}  </p>
                    <p v-if="dataBACTSpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataBACTSpecLN.status.name }} </p>
                </div>
                <div class="level-item">
                    <b-icon icon="lock" type="is-danger"  v-if="dataBACTSpecLN.status.id >=5 "  ></b-icon>
                    <b-icon icon="lock-open" type="is-success"  v-if="dataBACTSpecLN.status.id < 5 "  ></b-icon>
                </div>
                <div class="level-item">
                    <p class="is-size-5"> Assigned for </p>
                </div>
                <div class="level-item">
                    <p class="is-size-5 has-text-grey"> &nbsp; {{ dataBACTSpecLN.assigned_to_user.name }}</p>
                </div>
                <div class="level-item">

                    <b-button type="is-success"
                              id="button_edit"
                              icon-left="pencil"
                              @click="showEditBact"
                              :disabled="!IDLABSelected.idlab "
                              v-if="
                                (
                                 (  ( dataBACTSpecLN && (userRoleFind(3) || userRoleFind(4)  ))     )
                                 ||
                                    ( dataBACTSpecLN && userIsAdmin )
                                 ||
                                  ( dataBACTSpecLN && dataBACTSpecLN.assigned_to_user.id === user_id )
                                 )  && dataBACTSpecLN.status.id <=5

                                 ">
                        Edit
                    </b-button>

                </div>
                <div class="level-item" v-if="dataBACTSpecLN.status.id >=5 && userRoleFind(6)">
                    <b-dropdown aria-role="menu" position="is-bottom-left" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf">
                        <template #trigger>
                            <b-button type="is-primary is-light" icon-left="file-pdf-box" icon-right="chevron-down"
                                      :loading="loadingReportFile" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf" aria-haspopup="menu">
                                View as Pdf(Text)
                            </b-button>
                        </template>
                        <b-dropdown-item aria-role="menuitem" @click="selectReportMethod('legacy', false)">PDF แบบเดิม</b-dropdown-item>
                        <b-dropdown-item aria-role="menuitem" :disabled="dataBACTSpecLN.status.id > 6"
                                         @click="selectReportMethod('reportlab', false)">PDF ReportLab</b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="level-item" v-if="dataBACTSpecLN.status.id >=5 && userRoleFind(6)">
                    <b-dropdown aria-role="menu" position="is-bottom-left" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf || !dataBACTSpecLN.display_title_image_for_nonadmin">
                        <template #trigger>
                            <b-button type="is-primary is-light" icon-left="file-pdf-box" icon-right="chevron-down"
                                      :loading="loadingImgReportFile" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf || !dataBACTSpecLN.display_title_image_for_nonadmin" aria-haspopup="menu">
                                View as Pdf(Images)
                            </b-button>
                        </template>
                        <b-dropdown-item aria-role="menuitem" @click="selectReportMethod('legacy', true)">PDF แบบเดิม</b-dropdown-item>
                        <b-dropdown-item aria-role="menuitem" :disabled="dataBACTSpecLN.status.id > 6"
                                         @click="selectReportMethod('reportlab', true)">PDF ReportLab</b-dropdown-item>
                    </b-dropdown>
                </div>


            </div>
            <div class="level-right" v-if="( (dataBACTSpecLN.assigned_to_user.id === user_id )||(userIsAdmin) )&& ( dataBACTSpecLN.status.id >= 5 &&dataBACTSpecLN.status.id <= 6)">
                <div class="level-item">
                    <b-button type="is-danger"
                              icon-left="plus"
                              class="btn_plus"
                              @click="plusSomething">Plus
                    </b-button>
                </div>
                <div class="level-item">
                    <b-field
                            :type="{ 'is-danger': hasErrorPlusSomethingSelected}"
                            :message="{ 'pls select  ': hasErrorPlusSomethingSelected}">
                        <b-select placeholder="Select Plus Type" v-model="plusSomethingSelected">
                            <option value = 0> {{headerInfoPrepare}} </option>
                            <option value = 1> {{findingAndContent}} </option>
                            <option value = 2> {{images_title}} </option>
                            <option value = 3> {{ClassificationOfDiseases}} </option>
                            <option value = 4> {{BacterialSelect}} </option>
                        </b-select>
                    </b-field>
                </div>
            </div>
        </nav>
        <hr>


        <div v-if="dataBACTSpecLN && dataBACTSpecLN.status.id >= 5 && dataBACTSpecLN.status.id <=6 ">


            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="dataBACTSpecLN.display_title_prepare_for_nonadmin ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="headerPrepareInfo"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconFileDocument"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->


            <div class="container" v-if="displayTitle(dataBACTSpecLN.dat_prepare.dat,dataBACTSpecLN.data_plus.dat_prepare,dataBACTSpecLN.display_title_prepare_for_nonadmin)  ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>


            <!--     Prepare   ---------------------------------------------------------------------------------------------------->
<!--            <div class="container"  v-if="dataBACTSpecLN && dataBACTSpecLN.dat_prepare.dat_txt.length>0  " >-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="headerPrepareInfo"-->
<!--                           :plus=false />-->
<!--                <div class="box"  >-->
<!--                    <div v-html="getDecodeFromBase64ToHtml(dataBACTSpecLN.dat_prepare.dat)" ></div>-->
<!--                </div>-->
<!--                <FooterPlus  :user_rec="dataBACTSpecLN.dat_prepare.user_rec"-->
<!--                             :date_rec=" getISO8601ToYearMonthDate(dataBACTSpecLN.dat_prepare.datetime_rec).date +' ' +getISO8601ToYearMonthDate(dataBACTSpecLN.dat_prepare.datetime_rec).month +' ' +getISO8601ToYearMonthDate(dataBACTSpecLN.dat_prepare.datetime_rec).year  "-->
<!--                             :time_rec=" getISO8601ToYearMonthDate(dataBACTSpecLN.dat_prepare.datetime_rec).hour +':' + getISO8601ToYearMonthDate(dataBACTSpecLN.dat_prepare.datetime_rec).minute"-->
<!--                             :userIsAdmin="userIsAdmin"-->
<!--                             :idToDelete = "dataBACTSpecLN.dat_prepare.id.toString()"-->
<!--                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"-->
<!--                             :labKind = "IDLABSelected.kind"-->
<!--                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--            </div>-->


<!--            <br>-->

            <!----------------------  Prepared   disPlayOrNot   dataBACTSpecLN && dataBACTSpecLN.dat_prepare.dat_txt.length>0  ------>
            <div class="container"  v-if="disPlayOrNot(dataBACTSpecLN ,dataBACTSpecLN.dat_prepare.dat_txt.length ,dataBACTSpecLN.dat_prepare.visible )" >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataBACTSpecLN.dat_prepare.visible "/>
                <div class="box"  >
                    <div  v-html="getDecodeFromBase64ToHtml( dataBACTSpecLN.dat_prepare.dat )"
                          :style= "getStyleVisibleFalseInContent(dataBACTSpecLN.dat_prepare.visible)" >
                    </div>
                </div>
                <FooterPlus  :user_rec="dataBACTSpecLN.dat_prepare.user_rec"
                             :date_rec="dataBACTSpecLN.dat_prepare.date_rec"
                             :time_rec="dataBACTSpecLN.dat_prepare.time_rec"
                             :user_delete="dataBACTSpecLN.dat_prepare.user_edit"
                             :date_delete="dataBACTSpecLN.dat_prepare.date_edit"
                             :time_delete="dataBACTSpecLN.dat_prepare.time_edit"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataBACTSpecLN.dat_prepare.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"
                             :labKind = "IDLABSelected.kind"
                             :canDelete ="dataBACTSpecLN.dat_prepare.visible"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div>



            <!--           Prepare Plus  ------------------------------------------------------------------------------------------>
<!--            <div class="container"  v-if="dataBACTSpecLN && dataBACTSpecLN.data_plus.dat_prepare.length>0" >-->
<!--                <div v-for="dat_prepare_plus in  dataBACTSpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="headerPrepareInfoPlus"-->
<!--                               :plus=true />-->
<!--                    <div class="box"  >-->
<!--                        <div v-html="getDecodeFromBase64ToHtml(dat_prepare_plus.dat)" ></div>-->
<!--                    </div>-->
<!--                    <FooterPlus  :user_rec="dat_prepare_plus.user_rec"-->
<!--                                 :date_rec="dat_prepare_plus.date_rec"-->
<!--                                 :time_rec="dat_prepare_plus.time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "dat_prepare_plus.id.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->

<!--                </div>-->
<!--            </div>-->
            <!----------------------- Prepare Plus  dataBACTSpecLN && dataBACTSpecLN.data_plus.dat_prepare.length>0 -->
            <div v-for="dat_prepare_plus in  dataBACTSpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">
                <div  class="container" v-if="disPlayOrNot(true,true,dat_prepare_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="headerPrepareInfoPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_prepare_plus.visible "
                    />
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_prepare_plus.dat)"  :style= "getStyleVisibleFalseInContent(dat_prepare_plus.visible)">
                        </div>
                    </div>
                    <FooterPlus  :user_rec="dat_prepare_plus.user_rec"
                                 :date_rec="dat_prepare_plus.date_rec"
                                 :time_rec="dat_prepare_plus.time_rec"
                                 :user_delete="dat_prepare_plus.user_edit"
                                 :date_delete="dat_prepare_plus.date_edit"
                                 :time_delete="dat_prepare_plus.time_edit"
                                 :canDelete ="dat_prepare_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_prepare_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                    />
                </div>
            </div>










            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="dataBACTSpecLN.display_title_prepare_for_nonadmin ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="headerPrepareInfo"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconFileDocument"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->
            <!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="dataBACTSpecLN.data_bact.length>0 || dataBACTSpecLN && dataBACTSpecLN.data_plus.data.length>0 ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="BacterialSelect"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconFileDocument"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->

            <div class="container" v-if="displayTitle(dataBACTSpecLN.data_bact.length, dataBACTSpecLN.data_plus.data , dataBACTSpecLN.display_title_databact_for_nonadmin )">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="BacterialSelect"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>

            <!--          Main content Table UI for Result Bact -->
            <!-- <div class="container"  v-if="dataBACTSpecLN && dataBACTSpecLN.data_bact.length>0  " > -->
                <div class="container"  v-if="dataBACTSpecLN && dataBACTSpecLN.display_title_databact_for_nonadmin || userIsAdmin " >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="BacterialSelect"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataBACTSpecLN.data_bact.visible "
                />

                <template  v-for="(data_bact , index ) in dataBACTSpecLN.data_bact">
                    <span :key="data_bact.idbact_uuid">
                          <div class="container box"   v-if="data_bact.visible ||userIsAdmin ">
                            <Each_Bact_Show
                                :data_each_bact =data_bact
                                :index = "index+1"
                                    
                             />
                   
                                <FooterPlus     v-if="data_bact.visible || userIsAdmin"
                                                :user_rec="data_bact.user_rec"
                                                :date_rec=" dateFromISOToFormat(data_bact.date_rec) "
                                                :time_rec=" timeFromISOToFormat(data_bact.time_rec)"
                                                :userIsAdmin="userIsAdmin"
                                                :user_delete="data_bact.user_edit"
                                                :date_delete="data_bact.date_edit"
                                                :time_delete="data_bact.time_edit"
                                                :canDelete ="data_bact.visible  ? true : false"
                                                :idToDelete = "data_bact.id.toString()"
                                                :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.bact_data"
                                                :labKind = "IDLABSelected.kind"
                                                @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                        
                         </div>
                    </span>
                </template>

                    <!-- <div   v-for="(data_bact , index ) in dataBACTSpecLN.data_bact"
                           :key="data_bact.idbact_uuid"
                           class="container box" > 
                  
                        <Each_Bact_Show
                                :data_each_bact =data_bact
                                :index = "index+1"
                                v-if="data_bact.visible ||userIsAdmin "
                        />
                  
                        <FooterPlus     v-if="data_bact.visible || userIsAdmin"
                                                :user_rec="data_bact.user_rec"
                                                :date_rec=" dateFromISOToFormat(data_bact.date_rec) "
                                                :time_rec=" timeFromISOToFormat(data_bact.time_rec)"
                                                :userIsAdmin="userIsAdmin"
                                                :user_delete="data_bact.user_edit"
                                                :date_delete="data_bact.date_edit"
                                                :time_delete="data_bact.time_edit"
                                                :canDelete ="data_bact.visible  ? true : false"
                                                :idToDelete = "data_bact.id.toString()"
                                                :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.bact_data"
                                                :labKind = "IDLABSelected.kind"
                                                @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                        
                    </div>  -->
            </div>
            <br>
            <!-- <div class="container"  v-if="dataBACTSpecLN && dataBACTSpecLN.data_bact.length>0  " >
               
            <FooterPlus    :user_rec="dataBACTSpecLN.data_bact[0].user_rec"
                           :date_rec=" dateFromISOToFormat(dataBACTSpecLN.data_bact[0].date_rec) "
                           :time_rec=" timeFromISOToFormat(dataBACTSpecLN.data_bact[0].time_rec)"
                           :userIsAdmin="userIsAdmin"
                           :user_delete="dataBACTSpecLN.data_bact[0].user_edit"
                           :date_delete="dataBACTSpecLN.data_bact[0].date_edit"
                           :time_delete="dataBACTSpecLN.data_bact[0].time_edit"
                           :canDelete ="dataBACTSpecLN.data_bact[0].visible  ? true : false"
                           :idToDelete = "IDLABSelected.idlab"
                           :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.bact_data"
                           :labKind = "IDLABSelected.kind"
                           @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div> -->





            <!--          Main content Table UI for Result Bact Plus  -->
            <div v-for="data_bact_each_idtime in dataBACTSpecLN.data_plus.data" :key="data_bact_each_idtime.idtime">
              <div class="container box "
                   v-if="disPlayOrNot(data_bact_each_idtime,
                                      data_bact_each_idtime.dat.length,
                                      data_bact_each_idtime.dat.length >0 ? data_bact_each_idtime.dat[0].visible : false)"
              >
                  <TitlePlus :datUserWhoView="getNameAndSurname"
                             :titleDisplay="BacterialSelect"
                             :plus=false
                             :showIcon = false
                             :showTitleDisplay = false
                             :visible = "data_bact_each_idtime.visible"
                  />
                  <div    v-for="(data_bact_each_idtime_each_dat,index)  in data_bact_each_idtime.dat" :key="data_bact_each_idtime_each_dat.idbact_uuid" >
                      <Each_Bact_Show
                              :data_each_bact =data_bact_each_idtime_each_dat
                              :index="index+1"
                      />
                      <br>
                      
                      
                  </div>


              </div>
                <div class="container">
                    {{data_bact_each_idtime.idtime}}
                     <FooterPlus
                            v-if="disPlayOrNot(data_bact_each_idtime,
                                      data_bact_each_idtime.dat.length,
                                      data_bact_each_idtime.dat.length >0 ? data_bact_each_idtime.dat[0].visible : false)"
                            :user_rec="data_bact_each_idtime.dat[0].user_rec_fn"
                            :date_rec="dateFromISOToFormat(dataBACTSpecLN.dat_prepare.datetime_rec)  "
                            :time_rec="timeFromISOToFormat(dataBACTSpecLN.dat_prepare.datetime_rec)  "
                            :user_delete="data_bact_each_idtime.dat[0].user_edit_fn === null  ? '' : data_bact_each_idtime.dat[0].user_edit_fn"
                            :date_delete="dateFromISOToFormat(data_bact_each_idtime.dat[0].date_edit)"
                            :time_delete="timeFromISOToFormat(data_bact_each_idtime.dat[0].time_edit)"
                            :canDelete ="data_bact_each_idtime.dat[0].visible"
                            :userIsAdmin="userIsAdmin"
                            :idToDelete = "data_bact_each_idtime.idtime.toString()"
                            :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.bact_data_plus"
                            :labKind = "IDLABSelected.kind"
                            @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>
                </div>

           </div>










            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="dataBACTSpecLN.display_title_ct_for_nonadmin ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="findingAndContent"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconFileDocument"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->

           <div class="container" v-if="displayTitle(dataBACTSpecLN.dat_ct.dat_txt.length , dataBACTSpecLN.data_plus.dat_ct , dataBACTSpecLN.display_title_ct_for_nonadmin)">
            <TitlePlus :datUserWhoView="getNameAndSurname"
                       :titleDisplay="findingAndContent"
                       :plus=false
                       :showIcon = true
                       :showDatUserWhoView = "false"
                       :showTitleDisplay = true
                       :iconToShow = "iconFileDocument"
                       :visible = "true"/>
            </div>
            <!--     Findings and contents   -------------------------------------------------------------------------------------->
            <div class="container"  v-if="disPlayOrNot(dataBACTSpecLN ,dataBACTSpecLN.dat_ct.dat_txt.length ,dataBACTSpecLN.dat_ct.visible )" >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataBACTSpecLN.dat_ct.visible "/>
                <div class="box"  >
                    <div  v-html="getDecodeFromBase64ToHtml( dataBACTSpecLN.dat_ct.dat )"
                          :style= "getStyleVisibleFalseInContent(dataBACTSpecLN.dat_ct.visible)" >
                    </div>
                </div>
                <FooterPlus  :user_rec="dataBACTSpecLN.dat_ct.user_rec"
                             :date_rec="dataBACTSpecLN.dat_ct.date_rec"
                             :time_rec="dataBACTSpecLN.dat_ct.time_rec"
                             :user_delete="dataBACTSpecLN.dat_ct.user_edit"
                             :date_delete="dataBACTSpecLN.dat_ct.date_edit"
                             :time_delete="dataBACTSpecLN.dat_ct.time_edit"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataBACTSpecLN.dat_ct.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct"
                             :labKind = "IDLABSelected.kind"
                             :canDelete ="dataBACTSpecLN.dat_ct.visible"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div>



            <!--           Content Plus  -->
<!--            <div class="container"  v-if="dataBACTSpecLN !== null && dataBACTSpecLN.data_plus.dat_ct.length>0" >-->
<!--                <div v-for="dat_content_plus in  dataBACTSpecLN.data_plus.dat_ct" :key="dat_content_plus.id">-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="findingAndContentPlus"-->
<!--                               :plus=true />-->
<!--                    <div class="box"  >-->
<!--                        <div v-html="getDecodeFromBase64ToHtml(dat_content_plus.dat)" ></div>-->
<!--                    </div>-->
<!--                    <FooterPlus  :user_rec="dat_content_plus.user_rec"-->
<!--                                 :date_rec="dat_content_plus.date_rec"-->
<!--                                 :time_rec="dat_content_plus.time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "dat_content_plus.id.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--                </div>-->
<!--            </div>-->




            <!----------------------- Content Plus  -->
            <div v-for="dat_ct_plus in  dataBACTSpecLN.data_plus.dat_ct" :key="dat_ct_plus.id_uuid">
                <div  class="container" v-if="disPlayOrNot(true,true,dat_ct_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="headerPrepareInfoPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_ct_plus.visible "
                    />
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_ct_plus.dat)"  :style= "getStyleVisibleFalseInContent(dat_ct_plus.visible)" >
                        </div>
                    </div>

                    <FooterPlus  :user_rec="dat_ct_plus.user_rec"
                                 :date_rec="dat_ct_plus.date_rec"
                                 :time_rec="dat_ct_plus.time_rec"
                                 :user_delete="dat_ct_plus.user_edit"
                                 :date_delete="dat_ct_plus.date_edit"
                                 :time_delete="dat_ct_plus.time_edit"
                                 :canDelete ="dat_ct_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_ct_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                    />
                </div>
            </div>














            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!-- Display Title if normal or plus existing  -->
<!--            <div  class="container"  v-if="dataBACTSpecLN.display_title_image_for_nonadmin " >-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="images_title"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconImage"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->

            <div  class="container"  v-if="displayTitle(dataBACTSpecLN.img.dat , dataBACTSpecLN.data_plus.img , dataBACTSpecLN.display_title_image_for_nonadmin)    " >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="images_title"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconImage"
                           :visible = "true"/>
            </div>


            <!----------------------  Images  ------>
<!--            <div class="container"  v-if="dataBACTSpecLN && dataBACTSpecLN.img.dat.length>0" >-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="images_title"-->
<!--                           :plus=false />-->
<!--                <br>-->
<!--                <ThumbnailImageList  v-if="dataPassThruImageList.length>0"-->
<!--                                     :modeThumbnailImageList="modeThumbnailImageList"-->
<!--                                     :dataPassThruImageList="dataPassThruImageList"-->
<!--                                     :plus="false"/>-->
<!--                <FooterPlus  :user_rec="dataBACTSpecLN.img.user_rec"-->
<!--                             :date_rec="dataBACTSpecLN.img.date_rec"-->
<!--                             :time_rec="dataBACTSpecLN.img.time_rec"-->
<!--                             :userIsAdmin="userIsAdmin"-->
<!--                             :idToDelete = "IDLABSelected.idlab"-->
<!--                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images"-->
<!--                             :labKind = "IDLABSelected.kind"-->
<!--                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--                <hr>-->
<!--            </div>-->

            <template v-if="disPlayOrNot(dataBACTSpecLN ,dataBACTSpecLN.img.dat.length ,
                                         dataBACTSpecLN.img.dat.length>0 ? dataBACTSpecLN.img.dat[0].visible : false  )">
                <div class="container"  v-if="dataBACTSpecLN && dataBACTSpecLN.img.dat.length>0 " >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="images_title"
                               :plus=false
                               :showDatUserWhoView = true
                               :showIcon = false
                               :showTitleDisplay = false
                    />



                    <ThumbnailImageList  v-if="dataPassThruImageList.length>0"
                                         :modeThumbnailImageList="modeThumbnailImageList"
                                         :dataPassThruImageList="dataPassThruImageList"
                                         :plus="false"/>


                    <FooterPlus  :user_rec="dataBACTSpecLN.img.user_rec"
                                 :date_rec="dataBACTSpecLN.img.date_rec"
                                 :time_rec="dataBACTSpecLN.img.time_rec"
                                 :user_delete="dataBACTSpecLN.img.user_edit"
                                 :date_delete="dataBACTSpecLN.img.date_edit"
                                 :time_delete="dataBACTSpecLN.img.time_edit"
                                 :canDelete ="dataBACTSpecLN.img.user_edit.length>0 ? false : true"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                </div>

            </template>





            <!--           Image Plus  --------------------------------------------------------------------------------------------->
<!--            <div class="container"  v-if="dataBACTSpecLN !== null && dataBACTSpecLN.data_plus.img.length>0" >-->
<!--                <div v-for=" img in dataBACTSpecLN.data_plus.img" :key="img.idtime">-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="ImagePlus"-->
<!--                               :plus=true />-->
<!--                    <br>-->
<!--                    <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="true"  />-->
<!--                    <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"-->
<!--                                 :date_rec="getDateRecImgPlusByIdTime(img.idtime)"-->
<!--                                 :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "img.idtime.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--                    <br>-->
<!--                </div>-->
<!--            </div>-->
<!--            <hr v-if="dataBACTSpecLN !== null && dataBACTSpecLN.img.dat.length>0">-->


            <div  class="container"  v-for=" img in dataBACTSpecLN.data_plus.img" :key="img.idtime">

                <template v-if="disPlayOrNot(true,true,img.visible[0])">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ImagePlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :showDatUserWhoView = true
                    />
                    <br>
                    <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="true"  />
                    <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"
                                 :date_rec="getDateRecImgPlusByIdTime(img.idtime)"
                                 :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"
                                 :user_delete="img.user_edit.length>0 ? img.user_edit[0] : '' "
                                 :date_delete="img.date_edit.length>0 ? img.date_edit[0] : '' "
                                 :time_delete="img.time_edit.length>0 ? img.time_edit[0] : ''"
                                 :canDelete ="img.visible.length>0 ? img.visible[0] : false"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "img.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                    <br>
                </template>
            </div>








            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!-- Display Title if normal or plus existing  -->
<!--            <div  class="container" v-if="  dataBACTSpecLN.display_title_diag_for_nonadmin ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="ClassificationOfDiseases"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconDx"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->

            <div  class="container" v-if=" displayTitle( dataBACTSpecLN.diag_code.dat , dataBACTSpecLN.data_plus.diag_code ,dataBACTSpecLN.display_title_diag_for_nonadmin )  ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="ClassificationOfDiseases"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconDx"
                           :visible = "true"/>
            </div>


            <!----------------------  Diagosis  ---------------------------------------------------------------------------------->

<!--            <div class="container"  v-if="dataBACTSpecLN && dataBACTSpecLN.diag_code.dat.length>0" >-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="ClassificationOfDiseases"-->
<!--                           :plus=false />-->
<!--                <b-table             :data=" dataBACTSpecLN.diag_code.dat "-->
<!--                                     bordered-->
<!--                                     striped-->
<!--                                     narrowed-->
<!--                                     hoverable-->
<!--                                     focusable-->
<!--                                     mobile-cards-->
<!--                                     v-if="dataBACTSpecLN.diag_code.dat.length>0">-->


<!--                    <b-table-column field="level1Name" label="Chapter" v-slot="props">-->
<!--                        {{ props.row.level1Name }}-->
<!--                    </b-table-column>-->

<!--                    <b-table-column field="level2Name" label="Body System" v-slot="props">-->
<!--                        {{ props.row.level2Name }}-->
<!--                    </b-table-column>-->

<!--                    <b-table-column field="level3Name" label="Organ/Tissue" v-slot="props">-->
<!--                        {{ props.row.level3Name }}-->
<!--                    </b-table-column>-->

<!--                    <b-table-column field="level4Name" label="Character/Subcategories" v-slot="props">-->
<!--                        {{ props.row.level4Name }}-->
<!--                    </b-table-column>-->

<!--                    <b-table-column field="level5Name" label="Extensions" v-slot="props">-->
<!--                        {{ props.row.level5Name }}-->
<!--                    </b-table-column>-->


<!--                    <b-table-column field="level5Name" label="Unclassified Descriptions" v-slot="props">-->
<!--                        {{ props.row.unClassifiedCodes }}-->
<!--                    </b-table-column>-->


<!--                    <b-table-column field="level5Name" label="%" v-slot="props">-->
<!--                        {{ props.row.labDiseasecodeAccurateName }}-->
<!--                    </b-table-column>-->


<!--                    <b-table-column field="level5Name" label="Remark"  v-slot="props">-->
<!--                        {{ props.row.comment }}-->
<!--                    </b-table-column>-->






<!--                </b-table>-->
<!--                <FooterPlus  :user_rec="dataBACTSpecLN.diag_code.user_rec"-->
<!--                             :date_rec="dataBACTSpecLN.diag_code.date_rec"-->
<!--                             :time_rec="dataBACTSpecLN.diag_code.time_rec"-->
<!--                             :userIsAdmin="userIsAdmin"-->
<!--                             :idToDelete = "IDLABSelected.idlab"-->
<!--                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code"-->
<!--                             :labKind = "IDLABSelected.kind"-->
<!--                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>-->
<!--                <br>-->
<!--            </div>-->
            <template v-if="disPlayOrNot(dataBACTSpecLN ,dataBACTSpecLN.diag_code.dat.length ,
                                         dataBACTSpecLN.diag_code.dat.length>0 ? dataBACTSpecLN.diag_code.dat[0].visible : false  )">
                <div class="container"  v-if="dataBACTSpecLN && dataBACTSpecLN.diag_code.dat.length>0" >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ClassificationOfDiseases"
                               :plus=false
                               :showIcon = false
                               :showDatUserWhoView = "true"
                               :showTitleDisplay = false
                    />
                    <b-table             :data="isEmpty ? [] : dataBACTSpecLN.diag_code.dat "
                                         bordered
                                         striped
                                         narrowed
                                         hoverable
                                         focusable
                                         mobile-cards
                    >


                        <b-table-column field="level1Name" label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>

                        <b-table-column field="level2Name" label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>

                        <b-table-column field="level3Name" label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>

                        <b-table-column field="level4Name" label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>

                        <b-table-column field="level5Name" label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Comment"  v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>
                    <FooterPlus  :user_rec="dataBACTSpecLN.diag_code.user_rec"
                                 :date_rec="dataBACTSpecLN.diag_code.date_rec"
                                 :time_rec="dataBACTSpecLN.diag_code.time_rec"

                                 :user_delete="dataBACTSpecLN.diag_code.user_edit"
                                 :date_delete="dataBACTSpecLN.diag_code.date_edit"
                                 :time_delete="dataBACTSpecLN.diag_code.time_edit"
                                 :canDelete ="dataBACTSpecLN.diag_code.user_edit.length>0 ? false : true"

                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>
                    <br>
                </div>

            </template>




            <!----------------------         Diagosis Plus   dataCytoSpecLN.data_plus.diag_code  v-if="dataCytoSpecLN.data_plus.diag_code.length>0"-->
<!--            <div class="container" v-if="dataBACTSpecLN.data_plus.diag_code.length>0">-->

<!--                <div  v-for="diag_code_plus in dataBACTSpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">-->

<!--                    <TitlePlus-->
<!--                            :datUserWhoView="getNameAndSurname"-->
<!--                            :titleDisplay="ClassificationOfDiseases"-->
<!--                            :plus=true-->
<!--                    />-->
<!--                    <b-table         :data="diag_code_plus.dat"-->
<!--                                     bordered-->
<!--                                     striped-->
<!--                                     narrowed-->
<!--                                     hoverable-->
<!--                                     focusable-->
<!--                                     mobile-cards-->
<!--                    >-->
<!--                        <b-table-column   label="Chapter" v-slot="props">-->
<!--                            {{ props.row.level1Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Body System" v-slot="props">-->
<!--                            {{ props.row.level2Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Organ/Tissue" v-slot="props">-->
<!--                            {{ props.row.level3Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Character/Subcategories" v-slot="props">-->
<!--                            {{ props.row.level4Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Extensions" v-slot="props">-->
<!--                            {{ props.row.level5Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column  label="Unclassified Descriptions" v-slot="props">-->
<!--                            {{ props.row.unClassifiedCodes }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column  label="%" v-slot="props">-->
<!--                            {{ props.row.labDiseasecodeAccurateName }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column  label="Remark" v-slot="props">-->
<!--                            {{ props.row.comment }}-->
<!--                        </b-table-column>-->

<!--                    </b-table>-->

<!--                    <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"-->
<!--                                 :date_rec="diag_code_plus.dat[0].date_rec"-->
<!--                                 :time_rec="diag_code_plus.dat[0].time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "diag_code_plus.idtime.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>-->
<!--                </div>-->
<!--            </div>-->

            <div  class="container"  v-for=" diag_code_plus in dataBACTSpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">
                <template v-if="disPlayOrNot(true,true,diag_code_plus.visible)">



                    <TitlePlus
                            :datUserWhoView="getNameAndSurname"
                            :titleDisplay="ClassificationOfDiseases"
                            :plus=true
                            :showIcon = false
                            :showTitleDisplay = false
                            :showDatUserWhoView = true
                    />
                    <b-table         :data="diag_code_plus.dat"
                                     bordered
                                     striped
                                     narrowed
                                     hoverable
                                     focusable
                                     mobile-cards
                    >
                        <b-table-column   label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>
                        <b-table-column   label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>
                        <b-table-column   label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>
                        <b-table-column   label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>
                        <b-table-column   label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>
                        <b-table-column  label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>
                        <b-table-column  label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>
                        <b-table-column  label="Remark" v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>

                    <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"
                                 :date_rec="diag_code_plus.dat[0].date_rec"
                                 :time_rec="diag_code_plus.dat[0].time_rec"
                                 :user_delete="diag_code_plus.dat[0].user_edit.length>0 ? diag_code_plus.dat[0].user_edit : '' "
                                 :date_delete="diag_code_plus.dat[0].date_edit.length>0 ? diag_code_plus.dat[0].date_edit : '' "
                                 :time_delete="diag_code_plus.dat[0].time_edit.length>0 ? diag_code_plus.dat[0].time_edit : '' "
                                 :canDelete ="diag_code_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "diag_code_plus.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />

                </template>
            </div>


<!--            &lt;!&ndash;          Request info   &ndash;&gt;-->
<!--            <div class="container"  v-if="dataBACTSpecLN" >-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="ClassificationOfDiseases"-->
<!--                           :plus=false-->
<!--                           :showIcon = false-->
<!--                           :showDatUserWhoView = "true"-->
<!--                           :showTitleDisplay = false-->
<!--                />-->
<!--                <div class="box">-->
<!--                    <FooterRequest :dataReqToFooter="dataBACTSpecLN.data_req"/>-->
<!--                </div>-->
<!--            </div>-->
            <br>
            <!---------------- Display Title if normal or plus existing  -->
            <div  class="container"  v-if="  dataBACTSpecLN ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="RequestedInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconInfoRequest"
                           :visible = "true"/>
            </div>
            <!-----------------     Request Info.  ----------------->
            <div class="container"  v-if="dataBACTSpecLN" >
                <TitlePlus
                        :datUserWhoView="getNameAndSurname"
                        :titleDisplay="RequestedInfo"
                        :plus=false
                        :showIcon = false
                        :showTitleDisplay = false
                        :showDatUserWhoView = true
                />
                <FooterRequest :dataReqToFooter="dataBACTSpecLN.data_req"/>
            </div>




        <!--   end of  >>>>>>   <div v-if="dataBACTSpecLN && dataBACTSpecLN.status.id >= 5 && dataBACTSpecLN.status.id <=6 ">          -->
        </div>

        <PlusEditor   v-if="isPlusEditor"
                      :isShowing="isPlusEditor"
                      :idlab="IDLABSelected.idlab"
                      :labKind="IDLABSelected.kind"
                      :submitTypePlusEdit="submitTypePlusEditTmp"
                      @close="closePlusEditor"
                      @closeWithChange="closePlusEditorWithChange" />


        <PlusImages  v-if="isPlusImages"
                     :isShowing="isPlusImages"
                     :idlab="IDLABSelected.idlab"
                     @closePlusImagesWithData="closePlusImagesWithData"
                     @closePlusImages="closePlusImages"/>


        <PlusSelectDiseaseCode v-if="isPlusSelectDiseaseCode"
                               :idlab="IDLABSelected.idlab"
                               :isShowing="isPlusSelectDiseaseCode"
                               @closePlusSelectDiseaseCode_WithChange = "closePlusSelectDiseaseCode_WithChange"
                               @closePlusSelectDiseaseCode="closePlusSelectDiseaseCode"/>


        <PlusBacterial  v-if="isPlusBact"
                       :idlab="IDLABSelected.idlab"
                       :isShowing="isPlusBact"
                       @closePlusBacterial_WithChange = "closePlusBacterial_WithChange"
                       @closePlusBacterial = "closePlusBacterial"/>



        <EditDocLabBact
                ref="EditDocLabBact"
                :isComponentModalActive="isBACTEditorShowing"
                :IDLABSelected="IDLABSelected"
                @close="closeEditDocLabBact"
        />


        <b-modal
                v-model="isSelectImgForMakePdf"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SelectImgForMakePdf
                    :arrImg = "arrPropsToImgReport"
                    @closeSelectImgForMakePdfWithDataWantTo="doReqImageReportFile"
                    @closeSelectImgForMakePdf="closeSelectImgForMakePdf"/>
        </b-modal>



    </div>
</template>

<script>
    /* eslint-disable */
    import { genUUID , getBaseURLAvartar , DATA_BACT_LN_MODEL , CALL_FROM } from '@/utils.js'
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import {mapState} from "vuex";
    import TitlePlus from "./Plus/TitlePlus";
    import getISO8601ToYearMonthDate from "../../mixins/methods/getISO8601ToYearMonthDate";
    import globalconst from "../../mixins/globalconst";
    import getDecodeFromBase64ToHtml from "../../mixins/methods/getDecodeFromBase64ToHtml";
    import FooterPlus from "./Plus/FooterPlus";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import FooterRequest from "./FooterRequest";
    import Each_Bact_Show from "./Bact/Each_Bact_Show";
    import EditDocLabBact from "./EditDocLabBact";
    import PlusEditor from "./Plus/PlusEditor";
    import PlusImages from "./Plus/PlusImages";
    import PlusSelectDiseaseCode from "./Plus/PlusSelectDiseaseCode";
    import PlusBacterial from "./Plus/PlusBacterial";
    import disPlayOrNot from "../../mixins/methods/disPlayOrNot";
    import getStyleVisibleFalseInContent from "../../mixins/methods/getStyleVisibleFalseInContent";
    import iconTitle from "../../mixins/data/iconTitle";
    import doBacterialReportLab from "../../mixins/methods/doBacterialReportLab";
    import doReportFile from "../../mixins/methods/doReportFile";
    import displayTitle from "../../mixins/methods/displayTitle";


    import  selectURL_NextFrom_DoReportFile_ByCallFrmVar from "../../mixins/methods/selectURL_NextFrom_DoReportFile_ByCallFrmVar";
    import FileSaver from "file-saver";

    import SelectImgForMakePdf from "./SelectImgForMakePdf/SelectImgForMakePdf";
    import {DateTime} from "luxon";
    import timeFromISOToFormat from "../../mixins/methods/timeFromISOToFormat";
    import dateFromISOToFormat from "../../mixins/methods/dateFromISOToFormat";

    export default {
        name: "Bact_EachID",
        props:{
            dataBACTSpecLN : DATA_BACT_LN_MODEL,
            IDLABSelected: null ,
        },
        components:{
            TitlePlus,
            FooterPlus,
            ThumbnailImageList,
            FooterRequest,
            Each_Bact_Show,
            EditDocLabBact,
            PlusEditor,
            PlusImages,
            PlusSelectDiseaseCode,
            PlusBacterial,
            SelectImgForMakePdf
        },
        mixins:[getStyleVisibleFalseInContent,disPlayOrNot,
                userRoleFind,getISO8601ToYearMonthDate,
                globalconst,getDecodeFromBase64ToHtml,
                iconTitle,doReportFile,doBacterialReportLab,displayTitle,
                timeFromISOToFormat , dateFromISOToFormat,
                selectURL_NextFrom_DoReportFile_ByCallFrmVar,],
        computed: {
            ...mapState({
                user_id: state => state.master_data.user_id,
                user_role: state => state.master_data.user_role,
                userIsAdmin: state => state.master_data.userIsAdmin,
                clientIP: state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
            getNameAndSurname: function(){
                const userFullName = localStorage.getItem('user_name_surname')

                return  `<p class="has-text-weight-light has-text-grey-lighter" style="color: #00b89c; padding-top: 15px">
                         View by ${userFullName}
                          ${this.getISO8601ToYearMonthDate(this.dataBACTSpecLN.current_datetime).date}
                          ${this.getISO8601ToYearMonthDate(this.dataBACTSpecLN.current_datetime).month}
                          ${this.getISO8601ToYearMonthDate(this.dataBACTSpecLN.current_datetime).year}
                          <i>
                          (
                          ${this.getISO8601ToYearMonthDate(this.dataBACTSpecLN.current_datetime).hour}
                          :
                          ${this.getISO8601ToYearMonthDate(this.dataBACTSpecLN.current_datetime).minute}
                          )
                          </i>
                          </p>`
                // return localStorage.getItem('user_name_surname')
            },
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]
                if(this.dataBACTSpecLN.img.dat.length>0) {
                    return this.dataBACTSpecLN.img.dat.map(dat => {
                        return {
                            id: genUUID(5),
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                            title: dat.title,
                            fileNameUploaded: dat.file,
                            fresh: false
                        }
                    })
                }else{
                    return []
                }
            }
        },
        methods:{
            // dateFromISOToFormat(_datDate){
            //     return  DateTime.fromISO(_datDate).toFormat('DD');
            // },
            // timeFromISOToFormat(_datTime){
            //     return  DateTime.fromISO(_datTime ).toFormat('T');
            // },

            closeSelectImgForMakePdf(){
                this.isSelectImgForMakePdf = false
            },

            selectReportMethod(engine, images) {
                if (this.loadingReportFile || this.loadingImgReportFile || this.isSelectImgForMakePdf) return
                if (engine === 'reportlab' && this.dataBACTSpecLN.status.id > 6) return
                this.reportEngine = engine
                if (images) this.reqImageReportFile()
                else this.reqReportFile(false, -1, [])
            },

            reqImageReportFile(){
                if  (this.dataBACTSpecLN.display_title_image_for_nonadmin){
                    // build arr
                    // {"id":1  , "descp": "lorem","select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/179452040286.jpg"}
                    // `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                    this.arrPropsToImgReport = []
                    //genUUID
                    this.dataBACTSpecLN.img.dat.forEach(dat=>{
                        if (dat.visible){
                            this.arrPropsToImgReport.push(   {"id":genUUID(5)  , "descp": "", "select": false,"url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}` , "file": dat.file }  )
                        }
                    })
                    //
                    for(var i =0 ; i<this.dataBACTSpecLN.data_plus.img.length;i++){
                        for(var j =0; j < this.dataBACTSpecLN.data_plus.img[i].visible.length ; j++){
                            if (this.dataBACTSpecLN.data_plus.img[i].visible[j]){
                                this.arrPropsToImgReport.push(
                                    {"id":genUUID(5)  , "descp": "", "select": false,
                                        "url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${this.dataBACTSpecLN.data_plus.img[i].file[j]}` ,
                                        "file": this.dataBACTSpecLN.data_plus.img[i].file[j]
                                    }
                                )
                            }
                        }

                    }


                    if ( this.arrPropsToImgReport.length >0 ){
                        this.isSelectImgForMakePdf = true
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Nothing Images`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }



                }

            },


            doReqImageReportFile(payload){
                this.isSelectImgForMakePdf = false
                var arr_img_data_want = []
                for(var i=0;i<payload.arrImg.length;i++){
                   if (payload.arrImg[i].select){
                       arr_img_data_want.push(payload.arrImg[i].file)
                   }
                }


                this.reqReportFile(true,parseInt( payload.num_of_col ) ,arr_img_data_want)


            },

            reqReportFile(pure_Img,col_if_pure_img,arr_img_data_want){
                let previewWindow = null
                if (this.reportEngine === 'reportlab') {
                    previewWindow = window.open('', '_blank')
                    if (!previewWindow) {
                        this.$buefy.dialog.alert({title: 'PDF Preview', message: 'กรุณาอนุญาต popup สำหรับเว็บไซต์นี้ แล้วลองอีกครั้ง', type: 'is-warning'})
                        return
                    }
                    previewWindow.opener = null
                    previewWindow.document.title = 'PDF Preview'
                    previewWindow.document.body.textContent = 'กำลังสร้าง PDF…'
                }
                if(pure_Img){
                    this.loadingImgReportFile = true
                    }else{
                    this.loadingReportFile = true
                }

                const useReportLab = this.reportEngine === 'reportlab'
                const report = useReportLab
                    ? this.doBacterialReportLab(pure_Img,col_if_pure_img,arr_img_data_want)
                    : this.doReportFile(this.IDLABSelected,this.clientIP,pure_Img,col_if_pure_img,arr_img_data_want)
                report.then(res=>{
                         if (useReportLab) {
                             if (previewWindow.closed) return
                             const blobUrl = URL.createObjectURL(res)
                             try {
                                 previewWindow.location.replace(blobUrl)
                             } catch (error) {
                                 URL.revokeObjectURL(blobUrl)
                                 throw error
                             }
                             // Keep the URL valid for the viewer's print/download actions.
                             const cleanup = window.setInterval(() => {
                                 if (previewWindow.closed) {
                                     URL.revokeObjectURL(blobUrl)
                                     window.clearInterval(cleanup)
                                 }
                             }, 1000)
                         }
                         else FileSaver.saveAs(this.selectURL_NextFrom_DoReportFile_ByCallFrmVar(res), `${res.file_name}.pdf`);
                         if(pure_Img){
                             this.loadingImgReportFile = false
                         }else{
                             this.loadingReportFile = false
                         }
                     })
                    .catch(err=>{
                        if (previewWindow && !previewWindow.closed) previewWindow.close()
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: String((err.response && err.response.data && err.response.data.msg) || err.message || 'ไม่สามารถสร้าง PDF ได้').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch])),
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
                    .finally(()=>{
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
            },








            closePlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = false
            },
            closePlusSelectDiseaseCode_WithChange(){
                // console.log('closePlusSelectDiseaseCode_WithChange')
                this.$emit('trigForPlusUpdate')
                this.isPlusSelectDiseaseCode = false
            },
            closePlusImagesWithData(){
                this.isPlusImages = false
                this.$emit('trigForPlusUpdate')
            },
            closePlusImages(){
                this.isPlusImages = false
            },
            closePlusEditor(){
                this.isPlusEditor = false
            },
            closePlusEditorWithChange(){
                this.$emit('trigForPlusUpdate')
                this.isPlusEditor = false
            },
            closeEditDocLabBact(){
                this.isBACTEditorShowing = false
            },
            showEditBact(){

                // this.$refs.EditDocLabPCR.loadOldDat()
                // this.$refs.EditDocLabPCR.isComponentModalActive = true
                //
                this.isBACTEditorShowing = true

            },
            showPlusImages(){
                this.isPlusImages = true
            },
            showPlusEditor(_type){
                this.submitTypePlusEditTmp = _type
                this.isPlusEditor = true
            },
            plusSomething(){
                if(this.plusSomethingSelected === null){
                    this.hasErrorPlusSomethingSelected = true
                    return
                }


                if(this.plusSomethingSelected  == 0){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.prepare)
                }else if (this.plusSomethingSelected  == 1){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.ct)
                }else if (this.plusSomethingSelected  == 2){
                    this.showPlusImages()
                }else if (this.plusSomethingSelected  == 3){
                    this.addPlusSelectDiseaseCode()
                }else if (this.plusSomethingSelected  == 4){
                    this.addPlusBacterial()
                }else {
                    return
                }
            },
            closePlusBacterial_WithChange(){
                this.isPlusBact = false
                this.$emit('trigForPlusUpdate')
            },
            closePlusBacterial(){
                this.isPlusBact = false
            },
            addPlusBacterial(){
                this.isPlusBact = true
            },
            addPlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = true
            },
            footerPlusWithChangeDisable(){
                this.$emit('trigForPlusUpdate')
            },
            getTimeRecImgPlusByIdTime(_idtime){
                const member  = this.dataBACTSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.time_rec[0]
            },
            getDateRecImgPlusByIdTime(_idtime){
                const member  = this.dataBACTSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.date_rec[0]
            },
            getUserRecImgPlusByIdTime(_idtime){
                const member  = this.dataBACTSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.user_rec[0]
            },
            dataPassThruImageListPlus(_idtime) {
                if(this.dataBACTSpecLN.data_plus.img.length>0) {
                    const member = this.dataBACTSpecLN.data_plus.img.find(data => data.idtime === _idtime)
                    var tmpArr = []
                    for (var i = 0; i <= member.id.length - 1; i++) {
                        const tmp = {
                            id: member.id[i],
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${member.file[i]}`,
                            title: member.title[i],
                            fileNameUploaded: member.file[i],
                            fresh: false
                        }
                        tmpArr.push(tmp)
                    }
                    return tmpArr
                }else{
                    return []
                }
            }
        },
        data(){
            return {
                hasErrorPlusSomethingSelected : false ,
                plusSomethingSelected : null,
                isBACTEditorShowing : false,

                modeThumbnailImageList : "view",
                submitTypePlusEditTmp : "",
                isPlusSelectDiseaseCode : false,
                isPlusImages : false,
                isPlusEditor : false,
                isPlusBact : false,

                isEmpty : false,


                reportEngine: 'legacy',
                isSelectImgForMakePdf : false,
                arrPropsToImgReport : []

            }
        },
        watch:{
            plusSomethingSelected :{
                immediate : true,
                handler : function (val) {
                    if(val !== null){
                        this.hasErrorPlusSomethingSelected = false
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>